import { css } from 'styled-components';
import { i as isMobile } from '../theme/style-mixins/isMobile/isMobile-701df069.js';

const formGroupColumnStyleMixin = /*#__PURE__*/css(["", " width:100%;padding:0;font-weight:initial;display:inline-flex;flex-direction:column;flex-wrap:nowrap;justify-content:flex-start;align-content:stretch;align-items:stretch;> *{margin-bottom:", ";margin-block-end:", ";:last-child{margin-bottom:0;margin-block-end:0;}}", ""], ({
  fullWidth,
  theme
}) => !fullWidth && `max-width: ${theme.form.input.maxWidth};`, ({
  theme
}) => theme.form.input.internalElementBlockSpacing, ({
  theme
}) => theme.form.input.internalElementBlockSpacing, isMobile(css(["", ";max-width:", ";> *{margin-bottom:", ";margin-block-end:", ";}"], ({
  theme
}) => theme.typography.mobile.base, ({
  theme
}) => theme.form.input.mobile.maxWidth, ({
  theme
}) => theme.form.input.mobile.internalElementBlockSpacing, ({
  theme
}) => theme.form.input.mobile.internalElementBlockSpacing)));
var formGroupColumnStyleMixin$1 = formGroupColumnStyleMixin;

export { formGroupColumnStyleMixin$1 as f };
//# sourceMappingURL=formGroupColumnStyleMixin-05298d5d.js.map
